<template>
  <div id="myaccount" class="-mx-3 -mt-4">
    <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the teacher details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <form
      v-on:submit.prevent="submitTeacher"
      id="schoolForm"
      ref="form"
      v-if="!isTeacherComplete"
    >
    <div
        v-if="hasAdminAccess"
        class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200"
      >
        <div class="mx-6">
          <label class="font-semibold text-gray-600">Account Type</label>
          <div class="mt-2 w-1/3 -ml-2">
            <Dropdown
          :options="teacherTypeDropdown"
          :selected="teacherTypeSelected"
          v-on:updateOption="updateTeacherType"
          class="text-left px-0 bg-white mr-0"
        ></Dropdown>
      </div>
        </div>
      </div>


      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600"> Teacher Name *</label>

            <input
              v-model="teacher.name"
              type="text"
              placeholder="Enter teacher name"
              required=""
            />

          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600">Teacher Email (username) *</label>

            <input
              v-model="teacher.email"
              type="text"
              placeholder="Enter email"
              required=""
            />
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>


      <div v-if="isNewTeacher" class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600">Teacher Password *</label>

            <input
              v-model="password"
              type="password"
              placeholder="Enter password"
              required=""
            />
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div v-if="hasAdminAccess" class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600">User Is Admin </label>
          <div class="flex py-4">
            <button
              type="button"
              class="
                hover:bg-gray-400 hover:bg-opacity-50
                selection-button
                mr-3
              "
              v-bind:class="[
                teacherIsAdmin
                  ? 'bg-action-blue bg-opacity-75 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="teacherIsAdmin = true"
            >
              <i
                class="fas"
                v-bind:class="
                  teacherIsAdmin ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              Yes - On
            </button>

            <button
              type="button"
              class="hover:bg-gray-400 hover:bg-opacity-50 selection-button"
              v-bind:class="[
                !teacherIsAdmin
                  ? 'bg-action-blue bg-opacity-75 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="teacherIsAdmin = false"
            >
              <i
                class="fas"
                v-bind:class="
                  !teacherIsAdmin ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              No - Off
            </button>
          </div>
          </div>
           <div class="mx-6">
          <label class="font-semibold text-gray-600">User Active </label>
          <div class="flex py-4">
            <button
              type="button"
              class="
                hover:bg-gray-400 hover:bg-opacity-50
                selection-button
                mr-3
              "
              v-bind:class="[
                teacherActive
                  ? 'bg-action-blue bg-opacity-75 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="teacherActive = true"
            >
              <i
                class="fas"
                v-bind:class="
                  teacherActive ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              Yes - On
            </button>

            <button
              type="button"
              class="hover:bg-gray-400 hover:bg-opacity-50 selection-button"
              v-bind:class="[
                !teacherActive
                  ? 'bg-action-blue bg-opacity-75 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="teacherActive = false"
            >
              <i
                class="fas"
                v-bind:class="
                  !teacherActive ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              No - Off
            </button>
          </div>
          </div>
        </div>
      

      <footer class="mb-20">
        <p
          v-if="validationInError"
          class="bg-red-400 rounded w-11/12 text-white p-4 mt-2"
        >
          <i class="fas fa-exclamation-circle pr-2 text-xl"></i>All required
          fields must be complete.
        </p>


        <div class="flex justify-between  text-left w-11/12 mt-6 ml-6 mb-20 pb-4">
          <button
            @click="submitForm()"
            type="button"
            :disabled="isDisabled"
            class="h-10 publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"
          >
            Save Changes
          </button>

          <button
          v-if="showDelete"
            @click="deletion()"
            type="button"
            class="h-10 publish-button bg-red-500 hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"
          >
            Delete Teacher
          </button>
        </div>
      </footer>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { teacherTypeMixin } from "@/mixins/teacherTypeMixin.js";

const Dropdown = () => import("@/components/Dropdown.vue");


export default {
  name: "myaccount",
  mixins: [teacherTypeMixin],
  props: {
    teacher: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isDisabled() {
      if (this.teacher.name === undefined || this.teacher.name.length < 1) {
        return true
      }
      if(this.teacher.email === undefined || this.teacher.email.length < 1) {
        return true;
      }

      if (this.isNewTeacher) {
        if(this.password === undefined || this.password.length < 5) {
          return true;
        }
      }

      return false
    },
    showForSchool() {
      return this.currentUser.isSchool;
    },
    showForCompany() {
      return this.currentUser.isSchool == false;
    },
    hasAdminAccess() {
      return this.currentUser.hasAdmin;
    },
    teacherTypeDropdown() {
      return this.teacherTypes;
    },
    isNewTeacher() {
      if (this.teacher.id > 0) {
        return false
      } else {
        return true
      }
    
    },
    showDelete() {
      return this.hasAdminAccess && this.isNewTeacher === false
    }
  },
  data() {
    return {
      isSaving: false,
      errored: false,
      isTeacherComplete: false,
      validationInError: false,
      teacherTypeSelected: {},
      password: '',
      teacherActive: false,
      teacherIsAdmin: false
    };
  },
  created() {
    this.teacherTypeSelected = this.teacherTypes[0]
    if (this.teacher.id > 0) {
      this.teacherTypeSelected = this.teacherType(this.teacher.usertype_id)
      this.teacherActive = this.teacher.active === 1 ? true :  false
      this.teacherIsAdmin = this.teacher.is_admin
    }
  },
  methods: {
    updateTeacherType(value) {
      this.teacherTypeSelected = value;
    },
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.processTeacher();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    submitTeacher() {
      console.log(this.password)
      if (this.isNewTeacher && this.password.length < 4) {
        this.alertDisplay("Password must be at least 5 characters");
        return 
      }

      if (this.teacher.name == "" || this.teacher.email == "") {
        this.alertDisplay("You have empty fields that are required");
      } else {
        this.processTeacher();
      }
    },
    alertDisplay(msg) {
      this.$swal({
        title: "Empty Fields",
        text: msg,
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    processTeacher() {
      this.isSaving = true;
      this.teacher.usertype_id = this.teacherTypeSelected.id
      this.teacher.active = this.teacherActive === true ? 1 : 0
      this.teacher.is_admin = this.teacherIsAdmin
      if (this.teacher.id > 0) {
        SchoolService.update("users", this.teacher.identifier, this.teacher)
        .then((response) => this.completion(true))
        .catch((err) => {
          this.failure(err);
        });
      } else {

        let payload = {
          "pass": this.password,
          "user": this.teacher
        }
        SchoolService.create("users", payload)
        .then((response) => this.completion(true))
        .catch((err) => {
          this.failure(err);
        });
      }

    },
    completion(val) {
      this.isSaving = false;
      this.$emit("teacher-edited");
    },
    failure(error) {
      this.isSaving = false;
      this.isTeacherComplete = false;
      this.errored = true;
      console.log("teacher update error " + error);
    },
    deletion() {
      this.$swal({
        title: "Delete Teacher - Are you sure",
        text: "You have selected to delete this teacher",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, continue to delete",
        cancelButtonText: "No, cancel",
        showCloseButton: false,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.confirmDelete(this.teacher.identifier);
        }
      });
    },
    confirmDelete(val) {
        SchoolService.delete("users", val)
        .then((response) => this.completion(true))
        .catch((err) => {
          console.log("Teacher delete error " + err);
        });
    },
  },
  components: {
    Dropdown
  },
};
</script>
<style lang="css" scoped>
.form-label {
  @apply block uppercase tracking-wide text-gray-700 text-xs font-bold  mb-2;
}

.form-input {
  @apply appearance-none block w-full  bg-gray-100  text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

input[type="text"], input[type="password"] {
  @apply m-0 px-0 py-2 border-none h-auto rounded-none;
}

input[type="text"]:focus {
  border-bottom: 1px solid #a0aec0;
}

::-webkit-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

::-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-ms-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}
</style>
